import config from 'config';
import axios from 'axios';
import Purify from 'dompurify';
import { FALLBACK_ACCEPT_TEXT } from 'modules/Payment/components/ConsentToProcessingPersonalData/constants';

export function fetchAcceptText() {
  let acceptTextUrl = `${config.basePath}/static/media/accept.txt`;

  if (process.env.NODE_ENV === 'development') {
    acceptTextUrl = `/static/media/accept.txt`;
  }

  return axios
    .get(acceptTextUrl, { responseType: 'text' })
    .then(({ data }) => {
      return Purify.sanitize(data);
    })
    .catch(() => {
      return FALLBACK_ACCEPT_TEXT;
    });
}
